import {
  selectSelectedCompanyGroupId,
  selectSelectedCompanyId,
} from 'app/containers/Company/slice/selectors';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { useMapSlice } from 'app/containers/Map/slice';
import { selectSelectedSeasonId } from 'app/containers/Season/slice/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useLoadPolygons = () => {
  const dispatch = useDispatch();
  const mapActions = useMapSlice().actions;

  const envId = useSelector(selectSelectedEnvId);
  const seasonId = useSelector(selectSelectedSeasonId);
  const companyId = useSelector(selectSelectedCompanyId);
  const companyGroupId = useSelector(selectSelectedCompanyGroupId);

  useEffect(() => {
    if (envId && seasonId) {
      // Load all polygons on map
      dispatch(
        mapActions.onLoad({ envId, seasonId, companyId, companyGroupId }),
      );
    }
  }, [mapActions, dispatch, envId, seasonId, companyId, companyGroupId]);

  return null;
};

export default useLoadPolygons;
